import { render, staticRenderFns } from "./my-goshop.vue?vue&type=template&id=2146113d&scoped=true"
import script from "./my-goshop.vue?vue&type=script&lang=js"
export * from "./my-goshop.vue?vue&type=script&lang=js"
import style0 from "./my-goshop.vue?vue&type=style&index=0&id=2146113d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2146113d",
  null
  
)

export default component.exports